require("./bootstrap");

import Vue from "vue";

import Vuex from "vuex";
Vue.use(Vuex);

import { createInertiaApp } from "@inertiajs/inertia-vue";
import { InertiaProgress } from "@inertiajs/progress";

import defaultLayout from "./layouts/default";
import centralLayout from "./layouts/central";
import tenantLayout from "./layouts/tenant";
import webLayout from "./layouts/web";

import translation from "./mixins/translation";

import vuetify from "./plugins/vuetify";
import wait from "./plugins/wait";
import "./plugins/vee-validate";
import "./plugins/vue-gates";
import "./plugins/vuex";
import "./plugins/vue-line-clamp";
import "./plugins/currency";
import "./plugins/vue2-google-map";
import "./plugins/vue-geolocation";
import "./plugins/vue-tel-input-vuetify";
import "./plugins/vuetify-loading-overlay";
import "./plugins/vue-otp-input";
import "./plugins/vue-apexcharts";
import "./plugins/vuetify-toast-snackbar-ng";
import "./plugins/vue-fire";
import "./plugins/vue-cookies";
import "./plugins/vue2-daterange-picker";
import "./plugins/vuetify-datetime-picker";
import "./plugins/vue-native-notification";
import "./mixins/components";
import "./mixins/forms";
import "./mixins/filters";

Vue.mixin(translation);
Vue.config.productionTip = false;

import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

InertiaProgress.init({
    showSpinner: false
});

createInertiaApp({
    resolve: name => {
        let parts = name.split("::");

        if (parts.length >= 2) {
            var page = require(`../../modules/${parts[0]}/resources/assets/js/pages/${parts[1]}.vue`)
                .default;
            var path = parts[1];
        } else {
            var page = require(`./pages/${name}`).default;
            var path = name;
        }

        if (page.layout === undefined && path.startsWith("central/")) {
            page.layout = centralLayout;
        } else if (page.layout === undefined && path.startsWith("tenant/")) {
            page.layout = tenantLayout;
        } else if (page.layout === undefined && path.startsWith("web/")) {
            page.layout = webLayout;
        } else {
            page.layout = page.layout || defaultLayout;
        }

        return page;
    },
    setup({ el, App, props }) {
        new Vue({
            vuetify,
            wait,
            render: h => h(App, props)
        }).$mount(el);
    }
});

Vue.prototype.$route = route;
